import React from 'react';

// Generic table renderer. columns: [{ key, header, render?: (row)=>node, width? }]
// onRowClick(row) opens the detail panel. Action column is auto-appended if actions provided.
const EntityTable = ({
    columns,
    rows,
    rowKey = 'id',
    onRowClick,
    actions, // (row) => node
    emptyMessage = 'Nothing found.',
}) => {
    if (!rows || rows.length === 0) {
        return <p className="empty-state">{emptyMessage}</p>;
    }
    return (
        <div className="entity-table-wrap">
            <table className="entity-table">
                <thead>
                    <tr>
                        {columns.map((c) => (
                            <th key={c.key} style={c.width ? { width: c.width } : undefined}>
                                {c.header}
                            </th>
                        ))}
                        {actions && <th className="actions-col">Actions</th>}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => {
                        const key =
                            typeof rowKey === 'function' ? rowKey(row) : row[rowKey];
                        return (
                            <tr
                                key={key}
                                className={onRowClick ? 'clickable' : ''}
                                onClick={onRowClick ? () => onRowClick(row) : undefined}
                            >
                                {columns.map((c) => (
                                    <td key={c.key}>
                                        {c.render ? c.render(row) : row[c.key] ?? '—'}
                                    </td>
                                ))}
                                {actions && (
                                    <td
                                        className="actions-col"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {actions(row)}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default EntityTable;
